import { GridColDef } from "@mui/x-data-grid-pro";
import { BaseListModal } from "../../components/base_list_modal";
import { StyledDataGrid } from "../../components/styled_data_grid";
import { EquipamentoMedicaoHistorico } from "../../domain/models/equipamento_medicao_historico";
import { CSSProperties, useMemo } from "react";
import dayjs from "dayjs";
import { Tooltip } from "@mui/material";

type Props = {
  open: boolean;
  loading: boolean;
  saving: boolean;
  itens: EquipamentoMedicaoHistorico[];
  onClose: () => void;
};

export const EquipamentoMedicaoHistoricoModal = ({
  open,
  loading,
  saving,
  itens,
  onClose,
}: Props) => {
  const columns = useMemo((): GridColDef[] => {
    return [
      {
        field: "equipamento",
        filterable: false,
        headerName: "Equipamento",
        flex: 1,
        minWidth: 100,
        sortable: false,
        renderCell: ({ value }) => {
          return (
            <div className="size-full flex flex-col justify-center py-1">
              {value}
            </div>
          );
        },
      },
      {
        field: "cor",
        filterable: false,
        headerName: "Cor",
        width: 40,
        minWidth: 40,
        sortable: false,
        valueGetter: (_, row) => ({ cor: row['cor'], corValor: row['corValor'], tipo: row['tipoMonitoramento'] }),
        renderCell: ({ value }) => {
          return (
            <div className="size-full flex flex-col justify-center py-1">
              {
                value.tipo === "Verificado" &&
                <Tooltip title={value['cor'] ?? "Nenhuma"}>
                  <div
                    style={{
                      backgroundColor: value['corValor'] as CSSProperties['color'] ?? 'transparent',
                    }}
                    className="h-[1.85rem] w-[1.0rem] rounded flex flex-col gap-0 justify-center items-center border">
                    <div className="flex flex-col gap-0 justify-center items-center"></div>
                  </div>
                </Tooltip>
              }
            </div>
          );
        },
      },
      {
        field: "tipoMonitoramento",
        filterable: false,
        headerName: "Tipo de Monitoramento",
        minWidth: 100,
        width: 100,
        sortable: false,
        renderCell: ({ value }) => {
          return (
            <div className="size-full flex flex-col justify-center py-1">
              {value}
            </div>
          );
        },
      },
      {
        field: "responsavel",
        filterable: false,
        headerName: "Responsável",
        flex: 1,
        minWidth: 100,
        sortable: false,
        renderCell: ({ value }) => {
          return (
            <div className="size-full flex flex-col justify-center py-1">
              {value}
            </div>
          );
        },
      },
      {
        field: "calibradoVerificado",
        filterable: false,
        headerName: "Calibrado/Verificado",
        flex: 1,
        minWidth: 100,
        sortable: false,
        renderCell: ({ value }) => {
          return (
            <div className="size-full flex flex-col justify-center py-1">
              {value}
            </div>
          );
        },
      },
      {
        field: "frequencia",
        filterable: false,
        headerName: "Frequência",
        minWidth: 80,
        width: 80,
        sortable: false,
        renderCell: ({ value }) => {
          return (
            <div className="size-full flex flex-col justify-center py-1">
              {value === null || value === undefined ? "-" : `${value} ${value > 1 ? "dias" : "dia"}`}
            </div>
          );
        },
      },
      {
        field: "dataVerificacao",
        filterable: false,
        headerName: "Data de Verificação",
        minWidth: 90,
        width: 90,
        sortable: false,
        renderCell: ({ value }) => {
          return (
            <div className="size-full flex flex-col justify-center py-1">
              {value ? dayjs.utc(value).local().format("DD/MM/YYYY") : ""}
            </div>
          );
        },
      },
      {
        field: "dataProxVerificacao",
        filterable: false,
        headerName: "Data da Próxima Verificação",
        minWidth: 90,
        width: 90,
        sortable: false,
        renderCell: ({ value }) => {
          return (
            <div className="size-full flex flex-col justify-center py-1">
              {value ? dayjs.utc(value).local().format("DD/MM/YYYY") : ""}
            </div>
          );
        },
      },
      {
        field: "observacao",
        filterable: false,
        headerName: "Observação",
        flex: 1,
        minWidth: 100,
        sortable: false,
        renderCell: ({ value }) => {
          return (
            <div className="size-full flex flex-col justify-center py-1">
              {value}
            </div>
          );
        },
      },
    ];
  }, [
  ]);

  return (
    <BaseListModal
      open={open}
      loading={loading}
      saving={saving}
      title="Histórico de Equipamento Medição"
      onClose={onClose}>
      <div className="flex flex-col w-full gap-2 py-1">
        <StyledDataGrid
          tableName="equipamento_medicao_historico"
          disableColumnMenu={false}
          showToolbar={true}
          disableRowSelectionOnClick={true}
          getRowHeight={() => 'auto'}
          textSize="pequeno"
          getRowId={(row: EquipamentoMedicaoHistorico) => row.idEquipamentoMedicaoHistorico}
          columns={columns}
          loading={loading}
          checkboxSelection={false}
          rows={itens}
          rowCount={itens.length}
        />
      </div>
    </BaseListModal>
  );
}